const it = {
    serviceCall: 'Il fornitore di servizi può chiamare',
    heading_request:        'Quali sono i dettagli della tua richiesta di lavoro?',
    valid_question1: 'Scrivi qui piu detagli possibili',
    valid_question2:        'Se non fornisci informazioni sufficienti,almeno 100 caratteri, questo influirà sul numero di preventivi che riceverai.',
    valid_question3: 'Dovresti inserire almeno 100 lettere.',
    image_question: 'Vuoi aggiungere immagini?',
    where_location: 'Dove ? (Luogo di lavoro)',
    location_validation:        'Non possiamo usare la tua posizione. Si prega di cercare la città o inserirla manualmente',
    userMyLocation: 'USA LA MIA POSIZIONE',
    enterCity: 'Inserisci il nome della tua città',
    when_job: 'Quando ? (data del lavoro)',
    answer_question: 'Vuoi rispondere a queste domande?',
    inputAnswer: 'Inserisci qui la tua risposta...',
    enterPhone: 'Inserisci il tuo telefono',
    phoneDescription:        'I nostri professionisti possono contattarti più velocemente se selezioni "Contattami al telefono".',
    enterPhoneNumber: 'Inserisci il tuo numero di telefono',
    sendRequest: 'INVIA RICHIESTA',
    alert_image: 'Carica almeno un\'immagine.',
    alert_description: 'Inserisci la descrizione.',
    alert_address: 'Inserisci il tuo indirizzo.',
    alert_one_option: 'Seleziona un\'opzione.',
    alert_pick_date: 'Si prega di data di ritiro.',
    alert_answer: "Per favore, rispondi alla domanda",
    alert_phone: 'Inserisci il numero di telefono.',
    request_success_msg:        'Congratulazioni! Hai inoltrato la tua richiesta con successo!',
    alert_close_description:        'Puoi ottenere preventivi gratuiti rispondendo a poche altre domande.',
    go_on: 'CONTINUA',
    quit: 'USCIRE',
    servicesCompanyReady: "Società di servizi pronta",
    allow_contacts: "Mostra il mio numero di telefono",
    dont_disturbme: "Non disturbarmi",
    only_phone: "Contattami solo telefonicamente",
    only_offers: "Inviami solo offerte",
    only_whatsapp: "Contattami solo tramite whatsapp",
  
    kEmailNullError: "Inserisci la tua email",
    kInvalidEmailError: "Perfavore Inserisci un'email valida",
    kPassNullError: "Per favore inserisci LA TUA password",
    kConfirmPasswordError: "Mancata corrispondenza della password",
    kShortPassError:        "La password è troppo corta, almeno 8 caratteri",
    kMatchPassError: "Le password non corrispondono",
    kNameNullError: "Inserisci il tuo nome e cognome",
    kPhoneNumberNullError:        "Per favore immetti il ​​tuo numero di telefono",

    email: 'E-mail',
    password: "Password",
    pleaseendteryouremail: 'Per favore inserisci la tua email',
    pleaseenteryourpassword: 'per favore inserisci LA TUA password',

    confirmpassword: 'Conferma password',

    name: 'Nome',


    Congratulation: 'Congratulazioni',
    requestPriority: 'Richiedi Priorita',

    high: "alto",
    free: 'Gratis',

    noSearchResult: 'Nessun risultato di ricerca',
    inputThree: 'Si prega di inserire almeno 3 lettere',


    selected_city: 'Città/e selezionate',


    specificTime: 'Tempo specifico (entro tre settimane)',
    inTwoMonth: 'In due mesi',
    inSixMonth: 'Tra sei mesi',
    onlyPrice: 'Sto solo cercando un prezzo',
    flexibleTime: 'Flessibile',

    asap: 'Appena possibile',

    lab_continue: 'Continua',

//CUSTOM
mainheading: 'Che tipo di servizi stai cercando?',
back: 'Indietro',
serviceErrHead: 'Servizio vuoto',
serviceError: 'Seleziona un servizio che stai cercando per continuare..',

requiredField: "campo obbligatorio",
requireDesc: 'Questo campo è obbligatorio.'



}

export default it;